/* eslint-disable max-len */
/**
 * Italian translations.
 */
export default {
  ACTION: {},
  ERROR: {
    DOWNLOAD_IMAGE: 'Non è stato possibile scaricare l\'immagine',
    ERROR: 'Errore'
  },
  HEADER: {
    DESCRIPTION: 'Descrizione',
    END_DATE: 'Fino al',
    ID: 'ID',
    START_DATE: 'Dal',
    TITLE: 'Titolo'
  },
  LABEL: {
    ACTIVES: 'Campagne attivi',
    CAMPAIGNS_SIGN_OR: 'O',
    CAMPAIGNS_SIGN_PLUS: '+',
    COUPON: 'Buono',
    DESCRIPTION: 'Descrizione',
    DESIGN_REQUESTS: 'Richieste di progettazione',
    DESIGN_REQUESTS_ACTIVES: 'Richieste di design attive',
    DESIGN_REQUESTS_TERMINATED: 'Richieste di design completate',
    DETAIL: 'Dettaglio',
    END_DATE: 'Fino al',
    FILES_TITLE: 'Risorse per le campagne',
    FILES_TITLE_DESIGN_REQUEST: 'Riserve per la richiesta di design',
    FINISHED: 'Finita',
    FINISHED_DESIGN_REQUEST: 'Finito',
    GENERATED: 'Generato',
    GENERIC_DESIGN: 'Progettazione generica',
    ID: 'ID',
    IN_PROGRESS: 'In corso',
    NO_ROWS_CAMPAIGNS: 'Nessuna campagna',
    NO_ROWS_DESIGN_REQUESTS: 'Nessuna richiesta di design',
    OFFER: 'Offerta',
    PREVIOUS_LEVEL: 'Livello precedente',
    START_DATE: 'Dal',
    STATUS: 'Stato',
    TERMINATED: 'Campagne Terminata',
    TITLE: 'Titolo',
    VALUE: 'Valore'
  },
  SENTENCE: {
    ATTACHMENT_DESCRIPTION:
      'Nessuna allegati per le campagne (per il momento).',
    ATTACHMENT_DESCRIPTION_DESIGN_REQUEST:
      'Nessun allegato per questa richiesta di design (per ora).',
    ATTACHMENT_TITLE: 'Nessuna allegati.'
  },
  SUCCESS: {},
  TOOLTIP: {}
};
